import * as React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import { IElementsById } from "core-integration/src/store/elements/types";
import { IPickLight } from "core-integration/src/store/entries/types";
import ElementDialogButton from "../ElementDialogButton";
import Shirt from "../Shirt";
import { Controls } from "../Pitch";
import { UnstyledButton } from "../Utils";
import StatusPitchElementData from "./StatusPitchElementData";

const StatusPitchElementWrap = styled.div`
  margin: 0 0.2rem;
  padding: 0.4rem 0;
  border-radius: 0.4rem;
  align-items: stretch;
`;

const StyledStatusPitchElement = styled.div`
  position: relative;
  width: 6rem;
  margin: auto;
  padding-right: 0.3rem;
  padding-left: 0.3rem;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    width: 7rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 10.5rem;
  }
`;

const StyledInfoControl = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    position: absolute;
    top: 0;
    right: 5px;
  }
`;

interface IPropsFromState {
  elementsById: IElementsById;
}

interface IPropsFromDispatch {
  showElementDialog: (elementId: number) => void;
}

interface IOwnProps {
  pick: IPickLight;
  renderElementMenu: () => void;
  renderPickValue: (pick: IPickLight) => React.ReactNode;
}

type Props = IPropsFromState & IPropsFromDispatch & IOwnProps;

const Squad: React.FC<Props> = ({
  pick,
  elementsById,
  renderElementMenu,
  renderPickValue,
}) => {
  const element = elementsById[pick.element];

  return (
    <StatusPitchElementWrap>
      <StyledStatusPitchElement>
        <UnstyledButton type="button" onClick={renderElementMenu}>
          <Shirt elementId={element.id} />
          <StatusPitchElementData
            element={element}
            value={renderPickValue(pick)}
          />
        </UnstyledButton>
        <Controls>
          <StyledInfoControl>
            <ElementDialogButton elementId={pick.element} />
          </StyledInfoControl>
        </Controls>
      </StyledStatusPitchElement>
    </StatusPitchElementWrap>
  );
};

const mapStateToProps = (state: RootState): IPropsFromState => ({
  elementsById: getElementsById(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatch): IPropsFromDispatch => ({
  showElementDialog: (elementId) => dispatch(showElementSummary(elementId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Squad);
